import { render } from "./WarningJournal.vue?vue&type=template&id=ae3c7358"
import script from "./WarningJournal.vue?vue&type=script&lang=js"
export * from "./WarningJournal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__